<template>
  <div class="root">
    <div id="container" ref="container"></div>
  </div>
</template>
<script>
export default {
  name: 'jessibucaPlayer',
  props: {
    videoUrl: {
      type: String,
      default: '',
    },
    videoId: {
      type: String,
      default: '',
    }
  },
  data() {
    return {
      jessibuca: null,
      version: '',
      wasm: false,
      vc: 'ff',
      playing: false,
      quieting: true,
      loaded: false, // mute
      showOperateBtns: true,
      showBandwidth: true,
      err: '',
      speed: 0,
      performance: '',
      volume: 1,
      rotate: 0,
      useWCS: false,
      useMSE: true,
      useOffscreen: true,
      recording: true,
      recordType: 'webm',
      scale: 0,
      streamid: '',
    };
  },
  created() {
    // if (this.$route.query.id) {
    //   this.streamid = this.$route.query.id
    // }
    if (this.videoId) {
      this.streamid = this.videoId
    }
  },
  mounted() {
    this.create();
    // window.onerror = (msg) => (this.err = msg);
  },
  beforeDestroy() {
    console.log('destroy')
    this.jessibuca.destroy();
  },
  methods: {
    create(options) {
      options = options || {};
      this.jessibuca = new window.Jessibuca(
        Object.assign(
          {
            container: this.$refs.container,
            playbackUrl: `#/manage/main.videoRecord?id=${this.streamid}&mediaIp=139.9.116.226&mediaPort=80`,
            videoBuffer: Number(1), // 缓存时长
            isResize: false,
            autoWasm: true,
            heartTimeout: 5,
            useMSE: false,
            // useWCS:true,
            wasmDecodeErrorReplay: true,
            text: '',
            // background: "bg.jpg",
            loadingText: '疯狂加载中...',
            // hasAudio:false,
            debug: true,
            supportDblclickFullscreen: true,
            showBandwidth: this.showBandwidth, // 显示网速
            operateBtns: {
              fullscreen: this.showOperateBtns,
              screenshot: this.showOperateBtns,
              play: this.showOperateBtns,
              audio: this.showOperateBtns,
              playback: true,
            },
            vod: this.vod,
            forceNoOffscreen: !this.useOffscreen,
            isNotMute: false,
            timeout: 10,
          },
          options
        )
      );
      this.jessibuca.play(this.videoUrl);

      this.jessibuca.on('playback', function (msg) {
        alert('on playback', msg);
      });
    },
    play() {
      this.jessibuca.play(this.videoUrl);
    },
    destroy() {
      if (this.jessibuca) {
        this.jessibuca.destroy();
      }
      // this.create();
      this.playing = false;
      this.loaded = false;
      this.performance = '';
    },
    urlMatch(url) {
      var srcRegex = /src="([^"]+)"/;
      var match = url.match(srcRegex);

      // 如果匹配成功，则获取src值
      if (match) {
        var srcValue = match[1];
        console.log('src value:', srcValue);
        // return srcValue
        return 'http://139.9.116.226:280/gb28181/21010100001320000302.flv'
      } else {
        console.log('src attribute not found');
      }
    },
  },
};
</script>
<style>
.root {
  display: flex;
  place-content: center;
}
#container {
  background: rgba(13, 14, 27, 0.7);
  width: 100%;
  height: 100%;
}

@media (max-width: 720px) {
  #container {
    width: 90vw;
    height: 52.7vw;
  }
}
</style>
